module.exports = "https://static.wmbcdn.com/uniweb/images/6b19b7546e4f417b4e2435c142919228.svg";